<template>
  <div>
    <div class="search-box">
      <a-space>
        <a-select style="width:120px" v-model="form.class_id">
          <a-select-option key="" value="">全部</a-select-option>
          <a-select-option
            v-for="(item, index) in classList"
            :key="index"
            :value="item.id"
            >{{ item.class_name }}</a-select-option
          >
        </a-select>
        <!--时间段筛选-->
        <!-- <a-range-picker
          style="width: 240px;"
          v-model="searchDate"
          @change="changeDateTime"
          show-time
        >
          <a-icon slot="suffixIcon" type="carry-out" />
        </a-range-picker> -->
        <!--搜索按钮-->
        <a-button shape="round" type="primary" @click="handleSearch">
          搜索
        </a-button>
        <!--重置按钮-->
        <a-button shape="round" type="default" round @click="reset">
          重置
        </a-button>
      </a-space>

      <!--导出数据表按钮-->
      <a-button shape="round" type="primary" style="float: right" @click="exportTable">
        导出数据表
      </a-button>
    </div>
    <!--表格-->
    <div style="background: #fff;">
      <a-table
      ref="table"
            :columns="columns"
            :data-source="data"
            :pagination="false"
            :row-key="(record, index) => index"
          >
          </a-table>
    </div>

    <!--分页-->
    <div style="margin-top: 20px;text-align:center">
      <a-pagination
        :total="total"
        :page-size="form.pageSize"
        v-model="form.currentPage"
        show-quick-jumper
        @change="pageChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { reportApi, leaderApi } from '../../../api/api-director';
import qs from 'qs';
import * as XLSX from 'xlsx'

export default {
  name: "reportClass",
  data() {
    return {
      msg: "Hello World!",
      pickerOptions: {},
      columns: [
        {
          title: "园所名称",
          key: "school_name",
          dataIndex: "school_name",
          scopedSlots: { customRender: "school_name" },
        },
        {
          title: "学期",
          key: "semester_name",
          dataIndex: "semester_name",
          scopedSlots: { customRender: "semester_name" },
        },
        {
          title: "活跃教师数",
          dataIndex: "act_teacher",
          key: "act_teacher",
        },
        {
          title: "活跃班级数",
          dataIndex: "act_cls",
          key: "act_cls",
        },
        {
          title: "活跃家庭数",
          key: "act_family",
          dataIndex: "act_family",
        },
        {
          title: "教师活跃率",
          key: "teacher_progress",
          dataIndex: "teacher_progress",
        },
      ],
      search: "", // 搜索关键字
      searchDate: null, // 时间段
      data: [], // 表格数据
      classList: [],
      total: 0,
      form: {
        class_id: "", // 班级id
        pageSize: 10, 
        currentPage: 1, 
        school_id: "", // 学校id
        // semester_id: "",
        // testfield_id:""
      },
      classId:[],
      resetForm: { // 重置表单
        class_id: "", // 班级id
        pageSize: 10,
        currentPage: 1,
        school_id: "", // 学校id
      }
    };
  },
  created() {
    this.form.school_id = this.school.id || ""; // 设置学校id
    this.resetForm.school_id = this.school.id || ""; // 设置学校id
    this.getList(); // 获取表格数据
    this.getClassList(); // 获取班级列表
  },
  computed: {
    ...mapState(["headers", "userInfo", "school"]),
  },
  watch: {
    school(newVal, oldVal) {
      this.form.school_id = newVal.id || ""; // 设置学校id
      this.resetForm.school_id = newVal.id || ""; // 设置学校id
      this.getList(); // 获取表格数据
      this.getClassList();
    }
  },
  methods: {
    pageChange() {
      this.getList(); // 获取表格数据
    },
    getClassList() {
      const form = {
        currentPage: 1,
        pageSize: 100,
        leader_id: this.userInfo.id,
        sid: this.$store.state.headers,
        school_id: this.school.id || ""
      };
      axios({
        method: "post",
        url: leaderApi.main + leaderApi.allClassList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify(form),
      }).then((res) => {
        this.classList = res.data.data;
      });
    },
    getList() {
      this.$axios({
        method: "POST",
        url: reportApi.main + reportApi.getSchoolStatisList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify(this.form),
      }).then(res => {
          if (res.data.result) { 
            this.data = res.data.data.map(item => {
              return {
                ...item,
                teacher_progress: `${Math.ceil(item.act_teacher/item.total_teacher)*100}%`, // 转换为百分比
              }
            })
          } else {
            this.data = []
          }
      }).catch(() => {
        this.data = []
        this.$message.error("获取班级数据失败，服务或者网络错误");
      });
    },
    handleSearch() {
      this.form.currentPage = 1; // 重置当前页为1
      this.getList(); // 调用获取表格数据的方法
    },
    reset() {
      this.form = { ...this.resetForm }; // 重置表单
      this.classId = []; // 重置班级id
    },
    exportTable() {
      const table = this.$refs.table; // 获取表格实例
      const data = table.dataSource; // 获取表格数据
      const workbook = XLSX.utils.book_new(); // 创建工作簿
      const worksheet = XLSX.utils.json_to_sheet(data); // 将数据转换为工作表
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1"); // 将工作表添加到工作簿中
      XLSX.writeFile(workbook, "table.xlsx"); // 导出文件
      this.$message.success("导出成功"); // 提示导出成功
      console.log("导出数据表");
    },
    // changeDateTime(e, time) {
    //   this.observeListForm.stime = time[0];
    //   this.observeListForm.etime = time[1];
    // },
  },
};
</script>

<style lang="less" scoped>
.search-box {
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}
</style>
